import s from '@/styles/components/ModalMainError.module.scss'
import { Button } from '@/components'

interface Props {
  title: string;
  detail: string;
  onReload: () => void;
}

function ModalMainError({ title, detail, onReload }: Props) {
  return (
    <div className={s.wrap}>
      <div className={s.content}>
        <h1 className={s.title}>{title}</h1>
        <p className={s.detail}>{detail}</p>
        <Button variant={'stroke'} size={'large'} className={s.reload} onClick={onReload}>
          새로고침
        </Button>
      </div>
    </div>
  )
}

export { ModalMainError }
